import { useState } from "react";
import { Head, Link, router } from "@inertiajs/react";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [processing, setProcessing] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setProcessing(true);
    router.post(
      "/users/sign_in",
      { user: { email, password, remember_me: rememberMe ? "1" : "0" } },
      { onFinish: () => setProcessing(false) },
    );
  }

  return (
    <AuthLayout>
      <Head>
        <title>Sign In</title>
        <meta
          name="description"
          content="Sign in to your Mimir Languages account."
        />
        <link rel="canonical" href="https://mimirlang.eu/users/sign_in" />
      </Head>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <p className="font-mono text-xs uppercase tracking-widest text-accent mb-4">
            Welcome back
          </p>
          <h1 className="font-serif text-3xl font-medium text-heading">
            Sign in to Mímir
          </h1>
        </div>

        <form
          onSubmit={handleSubmit}
          noValidate
          className="flex flex-col gap-5"
        >
          <Input
            id="email"
            label="Email"
            type="email"
            autoComplete="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <Input
            id="password"
            label="Password"
            type="password"
            autoComplete="current-password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="flex items-center justify-between text-xs font-light text-muted">
            <label className="flex items-center gap-3 cursor-pointer select-none min-h-[44px]">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="accent-accent w-4 h-4 focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1 rounded-sm"
              />
              Remember me
            </label>
            <Link
              href="/users/password/new"
              className="hover:text-body transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded py-1 px-1 min-h-[44px] flex items-center"
            >
              Forgot password?
            </Link>
          </div>

          <Button type="submit" variant="filled" disabled={processing} className="w-full mt-2">
            {processing ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="mt-8 text-center text-xs text-muted font-light">
          No account?{" "}
          <Link
            href="/users/sign_up"
            className="text-body hover:text-heading transition-colors duration-200 underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
          >
            Create one
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
